var map = {
	"./square/ac.svg": 1752,
	"./square/ad.svg": 1753,
	"./square/ae.svg": 1754,
	"./square/af.svg": 1755,
	"./square/ag.svg": 1756,
	"./square/ai.svg": 1757,
	"./square/al.svg": 1758,
	"./square/am.svg": 1759,
	"./square/ao.svg": 1760,
	"./square/aq.svg": 1761,
	"./square/ar.svg": 1762,
	"./square/as.svg": 1763,
	"./square/at.svg": 1764,
	"./square/au.svg": 1765,
	"./square/aw.svg": 1766,
	"./square/ax.svg": 1767,
	"./square/az.svg": 1768,
	"./square/ba.svg": 1769,
	"./square/bb.svg": 1770,
	"./square/bd.svg": 1771,
	"./square/be.svg": 1772,
	"./square/bf.svg": 1773,
	"./square/bg.svg": 1774,
	"./square/bh.svg": 1775,
	"./square/bi.svg": 1776,
	"./square/bj.svg": 1777,
	"./square/bl.svg": 1778,
	"./square/bm.svg": 1779,
	"./square/bn.svg": 1780,
	"./square/bo.svg": 1781,
	"./square/bq.svg": 1782,
	"./square/br.svg": 1783,
	"./square/bs.svg": 1784,
	"./square/bt.svg": 1785,
	"./square/bv.svg": 1786,
	"./square/bw.svg": 1787,
	"./square/by.svg": 1788,
	"./square/bz.svg": 1789,
	"./square/ca.svg": 1790,
	"./square/cc.svg": 1791,
	"./square/cd.svg": 1792,
	"./square/cefta.svg": 1793,
	"./square/cf.svg": 1794,
	"./square/cg.svg": 1795,
	"./square/ch.svg": 1796,
	"./square/ci.svg": 1797,
	"./square/ck.svg": 1798,
	"./square/cl.svg": 1799,
	"./square/cm.svg": 1800,
	"./square/cn.svg": 1801,
	"./square/co.svg": 1802,
	"./square/cp.svg": 1803,
	"./square/cr.svg": 1804,
	"./square/cu.svg": 1805,
	"./square/cv.svg": 1806,
	"./square/cw.svg": 1807,
	"./square/cx.svg": 1808,
	"./square/cy.svg": 1809,
	"./square/cz.svg": 1810,
	"./square/de.svg": 1811,
	"./square/dg.svg": 1812,
	"./square/dj.svg": 1813,
	"./square/dk.svg": 1814,
	"./square/dm.svg": 1815,
	"./square/do.svg": 1816,
	"./square/dz.svg": 1817,
	"./square/ea.svg": 1818,
	"./square/ec.svg": 1819,
	"./square/ee.svg": 1820,
	"./square/eg.svg": 1821,
	"./square/eh.svg": 1822,
	"./square/er.svg": 1823,
	"./square/es-ct.svg": 1824,
	"./square/es-ga.svg": 1825,
	"./square/es.svg": 1826,
	"./square/et.svg": 1827,
	"./square/eu.svg": 1828,
	"./square/fi.svg": 1829,
	"./square/fj.svg": 1830,
	"./square/fk.svg": 1831,
	"./square/fm.svg": 1832,
	"./square/fo.svg": 1833,
	"./square/fr.svg": 1834,
	"./square/ga.svg": 1835,
	"./square/gb-eng.svg": 1836,
	"./square/gb-nir.svg": 1837,
	"./square/gb-sct.svg": 1838,
	"./square/gb-wls.svg": 1839,
	"./square/gb.svg": 1840,
	"./square/gd.svg": 1841,
	"./square/ge.svg": 1842,
	"./square/gf.svg": 1843,
	"./square/gg.svg": 1844,
	"./square/gh.svg": 1845,
	"./square/gi.svg": 1846,
	"./square/gl.svg": 1847,
	"./square/gm.svg": 1848,
	"./square/gn.svg": 1849,
	"./square/gp.svg": 1850,
	"./square/gq.svg": 1851,
	"./square/gr.svg": 1852,
	"./square/gs.svg": 1853,
	"./square/gt.svg": 1854,
	"./square/gu.svg": 1855,
	"./square/gw.svg": 1856,
	"./square/gy.svg": 1857,
	"./square/hk.svg": 1858,
	"./square/hm.svg": 1859,
	"./square/hn.svg": 1860,
	"./square/hr.svg": 1861,
	"./square/ht.svg": 1862,
	"./square/hu.svg": 1863,
	"./square/ic.svg": 1864,
	"./square/id.svg": 1865,
	"./square/ie.svg": 1866,
	"./square/il.svg": 1867,
	"./square/im.svg": 1868,
	"./square/in.svg": 1869,
	"./square/io.svg": 1870,
	"./square/iq.svg": 1871,
	"./square/ir.svg": 1872,
	"./square/is.svg": 1873,
	"./square/it.svg": 1874,
	"./square/je.svg": 1875,
	"./square/jm.svg": 1876,
	"./square/jo.svg": 1877,
	"./square/jp.svg": 1878,
	"./square/ke.svg": 1879,
	"./square/kg.svg": 1880,
	"./square/kh.svg": 1881,
	"./square/ki.svg": 1882,
	"./square/km.svg": 1883,
	"./square/kn.svg": 1884,
	"./square/kp.svg": 1885,
	"./square/kr.svg": 1886,
	"./square/kw.svg": 1887,
	"./square/ky.svg": 1888,
	"./square/kz.svg": 1889,
	"./square/la.svg": 1890,
	"./square/lb.svg": 1891,
	"./square/lc.svg": 1892,
	"./square/li.svg": 1893,
	"./square/lk.svg": 1894,
	"./square/lr.svg": 1895,
	"./square/ls.svg": 1896,
	"./square/lt.svg": 1897,
	"./square/lu.svg": 1898,
	"./square/lv.svg": 1899,
	"./square/ly.svg": 1900,
	"./square/ma.svg": 1901,
	"./square/mc.svg": 1902,
	"./square/md.svg": 1903,
	"./square/me.svg": 1904,
	"./square/mf.svg": 1905,
	"./square/mg.svg": 1906,
	"./square/mh.svg": 1907,
	"./square/mk.svg": 1908,
	"./square/ml.svg": 1909,
	"./square/mm.svg": 1910,
	"./square/mn.svg": 1911,
	"./square/mo.svg": 1912,
	"./square/mp.svg": 1913,
	"./square/mq.svg": 1914,
	"./square/mr.svg": 1915,
	"./square/ms.svg": 1916,
	"./square/mt.svg": 1917,
	"./square/mu.svg": 1918,
	"./square/mv.svg": 1919,
	"./square/mw.svg": 1920,
	"./square/mx.svg": 1921,
	"./square/my.svg": 1922,
	"./square/mz.svg": 1923,
	"./square/na.svg": 1924,
	"./square/nc.svg": 1925,
	"./square/ne.svg": 1926,
	"./square/nf.svg": 1927,
	"./square/ng.svg": 1928,
	"./square/ni.svg": 1929,
	"./square/nl.svg": 1930,
	"./square/no.svg": 1931,
	"./square/np.svg": 1932,
	"./square/nr.svg": 1933,
	"./square/nu.svg": 1934,
	"./square/nz.svg": 1935,
	"./square/om.svg": 1936,
	"./square/pa.svg": 1937,
	"./square/pe.svg": 1938,
	"./square/pf.svg": 1939,
	"./square/pg.svg": 1940,
	"./square/ph.svg": 1941,
	"./square/pk.svg": 1942,
	"./square/pl.svg": 1943,
	"./square/pm.svg": 1944,
	"./square/pn.svg": 1945,
	"./square/pr.svg": 1946,
	"./square/ps.svg": 1947,
	"./square/pt.svg": 1948,
	"./square/pw.svg": 1949,
	"./square/py.svg": 1950,
	"./square/qa.svg": 1951,
	"./square/re.svg": 1952,
	"./square/ro.svg": 1953,
	"./square/rs.svg": 1954,
	"./square/ru.svg": 1955,
	"./square/rw.svg": 1956,
	"./square/sa.svg": 1957,
	"./square/sb.svg": 1958,
	"./square/sc.svg": 1959,
	"./square/sd.svg": 1960,
	"./square/se.svg": 1961,
	"./square/sg.svg": 1962,
	"./square/sh.svg": 1963,
	"./square/si.svg": 1964,
	"./square/sj.svg": 1965,
	"./square/sk.svg": 1966,
	"./square/sl.svg": 1967,
	"./square/sm.svg": 1968,
	"./square/sn.svg": 1969,
	"./square/so.svg": 1970,
	"./square/sr.svg": 1971,
	"./square/ss.svg": 1972,
	"./square/st.svg": 1973,
	"./square/sv.svg": 1974,
	"./square/sx.svg": 1975,
	"./square/sy.svg": 1976,
	"./square/sz.svg": 1977,
	"./square/ta.svg": 1978,
	"./square/tc.svg": 1979,
	"./square/td.svg": 1980,
	"./square/tf.svg": 1981,
	"./square/tg.svg": 1982,
	"./square/th.svg": 1983,
	"./square/tj.svg": 1984,
	"./square/tk.svg": 1985,
	"./square/tl.svg": 1986,
	"./square/tm.svg": 1987,
	"./square/tn.svg": 1988,
	"./square/to.svg": 1989,
	"./square/tr.svg": 1990,
	"./square/tt.svg": 1991,
	"./square/tv.svg": 1992,
	"./square/tw.svg": 1993,
	"./square/tz.svg": 1994,
	"./square/ua.svg": 1995,
	"./square/ug.svg": 1996,
	"./square/um.svg": 1997,
	"./square/un.svg": 1998,
	"./square/us.svg": 1999,
	"./square/uy.svg": 2000,
	"./square/uz.svg": 2001,
	"./square/va.svg": 2002,
	"./square/vc.svg": 2003,
	"./square/ve.svg": 2004,
	"./square/vg.svg": 2005,
	"./square/vi.svg": 2006,
	"./square/vn.svg": 2007,
	"./square/vu.svg": 2008,
	"./square/wf.svg": 2009,
	"./square/ws.svg": 2010,
	"./square/xk.svg": 2011,
	"./square/xx.svg": 2012,
	"./square/ye.svg": 2013,
	"./square/yt.svg": 2014,
	"./square/za.svg": 2015,
	"./square/zm.svg": 2016,
	"./square/zw.svg": 2017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1751;